import { createApp } from 'vue'
import App from './App.vue'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import ApiService from '@/assets/js/apiService'; // 引入 ApiService 實例
import Parameters from '@/assets/js/parameters'
import shareds from '@/assets/js/shared'


import '@/assets/css/dcp.css'

const app = createApp(App);

const apiService = new ApiService(app);
const parameter = new Parameters()
const shared = new shareds()

app.config.globalProperties.$api = apiService;
app.config.globalProperties.$parameter = parameter;
app.config.globalProperties.$shared = shared;
//處理版本號碼
import packageJson from '../package.json'
app.config.globalProperties.$version = process.env.VUE_APP_ENV_NAME === 'production' ? packageJson.version : `${process.env.VUE_APP_ENV_NAME}.${packageJson.version}`

apiService.debug = app.config.globalProperties.$debug
apiService.router = router
apiService.store = store

app.use(router);
app.use(store);
app.use(i18n)
app.mount('#app');
  
